module.exports = __webpack_public_path__ + "static/media/Eje-Final.777ccd89.jpg";